export default "__VITE_ASSET__zk8a2i4O__"